const BASE_INTERVAL = 3000;
const MAX_INTERVAL = 30000;

const createTranslationPollInterval =
  ({ total }) =>
  (jobData, attempt) => {
    const succeeded = Object.values(jobData?.results?.succeeded || {}).flat().length;
    const failed = Object.values(jobData?.results?.failed || {}).flatMap((pageMap) =>
      Object.keys(pageMap)
    ).length;
    const done = succeeded + failed;

    if (total - done <= 1) {
      return BASE_INTERVAL;
    }

    return Math.min(BASE_INTERVAL * 2 ** attempt, MAX_INTERVAL);
  };

export default createTranslationPollInterval;
